import { FAV_ACTION_TYPES } from "./actionTypes";

const initialState = {
    items: [],
};

export const favoritesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FAV_ACTION_TYPES.TOGGLE_ITEM: {
            const product = action.payload;
            const existingIndex = state.items.findIndex(item => item.id === product.id);

            if (existingIndex !== -1) {
                return {
                    ...state,
                    items: state.items.filter(item => item.id !== product.id),
                };
            } else {
                return {
                    ...state,
                    items: [...state.items, product]
                };
            }
        }

        case FAV_ACTION_TYPES.CLEAR_FAVORITES: {
            return {
                ...state,
                items: [],
            };
        }

        default:
            return state;
    }
};